import React from 'react';
import '../../assets/css/case-home.css';
import caseBackgroundIcon from '../../assets/images/case-background-dark.svg';
import type { ComponentContentSchema } from '@vibesites/runtime';
// @ts-ignore
import { useContentToken, EditableToken } from '@vibesites/runtime/react';

export function AboutPageHero() {
  const title = useContentToken('aboutpagehero.title');

  return (
    <section className="case-aboutpage-hero">
      <div className="case-aboutpage-hero-overlay" role="presentation" aria-hidden="true">
        <img src={caseBackgroundIcon} alt="Case & Associates logo accent background" />
      </div>
      <div className="case-container">
        <nav aria-label="Breadcrumb">
          <ol className="case-breadcrumb">
            <li><a href="/">Home</a></li>
            <li aria-current="page">
              <EditableToken path="aboutpagehero.title" type="text" label="Page Title" defaultValue={contentSchema.tokens['aboutpagehero.title'].defaultValue} as="span">
                {title}
              </EditableToken>
            </li>
          </ol>
        </nav>
        <EditableToken
          path="aboutpagehero.title"
          type="text"
          label="Page Title"
          defaultValue={contentSchema.tokens['aboutpagehero.title'].defaultValue}
          as="h1"
          style={{ fontSize: '2.5rem', fontWeight: 700, lineHeight: 1.2, margin: '0.25rem 0 0' }}
        >
          {title}
        </EditableToken>
        <div style={{ width: 60, height: 4, background: 'var(--case-primary, #ED1C24)', marginTop: '1rem' }} />
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'AboutPageHero',
  displayName: 'About Page Hero',
  tokens: {
    'aboutpagehero.title': {
      label: 'Page Title',
      type: 'text',
      defaultValue: 'About Us',
    },
  },
};

(AboutPageHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default AboutPageHero;
